import { useTranslation } from "react-i18next"

import { useAccessibilityMessage } from "shared/types/useAccessibilityMessage"

interface UseProjectsOverviewPageAccessibilityProps {
  containsFocus: boolean
  focusedIndex: number
  projectCount: number
  rowCount: number
  columnCount: number
}

export function useProjectsOverviewPageAccessibility({
  containsFocus,
  focusedIndex,
  projectCount,
  columnCount,
  rowCount
}: UseProjectsOverviewPageAccessibilityProps) {
  const { t } = useTranslation()
  useAccessibilityMessage(
    containsFocus
      ? {
          id: "focused-project-message",
          text: t("ProjectsOverviewPage.Accessibility.ProjectTileFocus", {
            index: focusedIndex + 1,
            total: projectCount,
            rowCount,
            columnCount
          })
        }
      : undefined
  )
}
